 
  //noinspection BadExpressionStatementJS,UnterminatedStatementJS
 define({ 
         ok: "확인",
         cancel: "취소",
         switchPanes: "창 전환",
         close: "닫기",
         yes: "예",
         no: "아니요"
     });

